export default "__VITE_ASSET__FkLdgD_8__"